import { render, staticRenderFns } from "./DeliveryMaker.vue?vue&type=template&id=f642fdf2&scoped=true"
import script from "./DeliveryMaker.vue?vue&type=script&lang=js"
export * from "./DeliveryMaker.vue?vue&type=script&lang=js"
import style0 from "./DeliveryMaker.vue?vue&type=style&index=0&id=f642fdf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f642fdf2",
  null
  
)

export default component.exports